__turbopack_context__.v({
  "address": "styles-module__6U8g1a__address",
  "archiveButton": "styles-module__6U8g1a__archiveButton",
  "badge": "styles-module__6U8g1a__badge",
  "deleteButton": "styles-module__6U8g1a__deleteButton",
  "description": "styles-module__6U8g1a__description",
  "editButton": "styles-module__6U8g1a__editButton",
  "icon": "styles-module__6U8g1a__icon",
  "iconButtonsContainer": "styles-module__6U8g1a__iconButtonsContainer",
  "morePhotosOverlay": "styles-module__6U8g1a__morePhotosOverlay",
  "price": "styles-module__6U8g1a__price",
  "profileObjectItem": "styles-module__6U8g1a__profileObjectItem",
  "profileObjectItemAction": "styles-module__6U8g1a__profileObjectItemAction",
  "profileObjectItemContent": "styles-module__6U8g1a__profileObjectItemContent",
  "profileObjectItemCounter": "styles-module__6U8g1a__profileObjectItemCounter",
  "profileObjectItemDD": "styles-module__6U8g1a__profileObjectItemDD",
  "profileObjectItemFooter": "styles-module__6U8g1a__profileObjectItemFooter",
  "profileObjectItemImage": "styles-module__6U8g1a__profileObjectItemImage",
  "rm": "styles-module__6U8g1a__rm",
  "thumbnailWrapper": "styles-module__6U8g1a__thumbnailWrapper",
  "title": "styles-module__6U8g1a__title",
});
